"use client";

import useServerTimeStore from "@/stores/useServerTimeStore";
import { fetchServerTime } from "@/lib/fetchServerTime";
import { useEffect } from "react";

const SYNC_INTERVAL_MS = 30000; // 30 seconds

const ActiveAuctionTimeSync = ({ isActive }: { isActive: boolean }) => {
  const { setServerTime } = useServerTimeStore();

  useEffect(() => {
    if (!isActive) return;

    const sync = () => fetchServerTime(setServerTime);
    const interval = setInterval(sync, SYNC_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isActive, setServerTime]);

  return null;
};

export default ActiveAuctionTimeSync;
